<template>
  <aside class="glass border-r border-orange-100 h-full flex flex-col">
    <div class="flex-1 px-4 py-6">
      <!-- 导航菜单 -->
      <nav class="space-y-2">
        <router-link
          v-for="item in navigationItems"
          :key="item.path"
          :to="item.path"
          :class="[
            'flex items-center space-x-3 px-4 py-3 rounded-xl font-medium transition-all duration-200',
            isActive(item.path)
              ? 'bg-orange-50 text-orange-700 border border-orange-200'
              : 'text-gray-600 hover:bg-orange-50 hover:text-orange-700'
          ]"
          @click="handleNavClick"
          data-router-link
        >
          <component :is="item.icon" class="w-5 h-5" />
          <span>{{ item.label }}</span>
        </router-link>
      </nav>

      <!-- AI医生推广卡片 -->
      <div class="mt-8 p-4 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100">
        <div class="text-center">
          <div class="w-12 h-12 bg-ai-gradient rounded-full flex items-center justify-center mx-auto mb-3">
            <Stethoscope class="w-6 h-6 text-white" />
          </div>
          <h3 class="font-semibold text-blue-900 mb-2">AI 猫咪医生</h3>
          <p class="text-sm text-blue-700 mb-4">专业的AI健康咨询，为您的猫咪提供24小时健康建议</p>
          <router-link to="/ai-doctor" class="btn-primary w-full block text-center" data-router-link>
            立即尝试
          </router-link>
        </div>
      </div>

      <!-- 社区活动卡片 -->
      <div class="mt-6 p-4 bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl border border-purple-100">
        <div class="text-center">
          <div class="w-12 h-12 bg-community-gradient rounded-full flex items-center justify-center mx-auto mb-3">
            <Users class="w-6 h-6 text-white" />
          </div>
          <h3 class="font-semibold text-purple-900 mb-2">猫友社区</h3>
          <p class="text-sm text-purple-700 mb-4">分享您的猫咪生活，与全球猫友交流</p>
          <router-link to="/community" class="bg-community-gradient text-white btn-primary w-full block text-center" data-router-link>
            加入社区
          </router-link>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="px-4 py-4 border-t border-orange-100">
      <p class="text-center text-xs text-gray-500">
        © {{new Date().getFullYear()}} 深圳市猫趴科技有限公司
      </p>
      <p class="text-center text-xs text-gray-500">
        Powered by 猫趴 & build with 💗
      </p>
      <p class="text-center text-xs text-gray-500">
        All Rights Reserved.
      </p>
    </div>

    <!-- 移动端关闭按钮 -->
    <button
      v-if="isMobile"
      class="absolute top-4 right-4 btn-icon"
      @click="$emit('close')"
    >
      <X class="w-5 h-5 text-gray-500" />
    </button>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import {
  Home,
  Store,
  Stethoscope,
  MessageCircle,
  User,
  Users,
  X
} from 'lucide-vue-next'

// 定义事件
defineEmits<{
  close: []
}>()

const route = useRoute()
const { width } = useWindowSize()

// 计算属性
const isMobile = computed(() => width.value < 768)

// 导航项目
const navigationItems = [
  {
    path: '/',
    label: '首页',
    icon: Home
  },
  {
    path: '/store',
    label: '商店',
    icon: Store
  },
  {
    path: '/ai-doctor',
    label: 'AI医生',
    icon: Stethoscope
  },
  {
    path: '/community',
    label: '社区',
    icon: MessageCircle
  }
]

// 方法
const isActive = (path: string) => {
  if (path === '/') {
    return route.path === '/'
  }
  return route.path.startsWith(path)
}

const handleNavClick = () => {
  // 移动端点击导航后关闭侧边栏
  if (isMobile.value) {
    // 延迟关闭以便导航动画完成
    setTimeout(() => {
      // 触发关闭事件
    }, 150)
  }
}
</script>

<style scoped>
/* 侧边栏样式已在global.css中定义 */
</style>

